// 资产图表组件国际化配置 - 英文
export default {
  // Chart titles
  balanceChange: "Total Asset Balance Change (Last 6 Months)",
  transactionBoard: "Transaction Board",
  unit: "Unit: USDT",

  // Tabs
  tabs: {
    balanceTrend: "Balance Trend",
    transactionOverview: "Transaction Board",
  },

  // Tooltips
  tooltips: {
    addToBoard:
      "You can right-click on the address in the canvas to add it to the transaction board",
    calculating:
      "Total asset balance change data is being calculated, please check later",
  },

  // Transaction statistics
  transaction: {
    earliestInflow: "Earliest Inflow (USDT)",
    earliestOutflow: "Earliest Outflow (USDT)",
    transactionCount: "Transaction Count",
    transactionAmount: "Transaction Amount",
    counterParty: "Counter Party",
  },

  // Common
  detail: "Details >",
  noData: "No data",
  loadingText: "Loading...",

  // Error messages
  errors: {
    loadChartFailed: "Failed to load chart data, please try again later",
    loadTransactionFailed:
      "Failed to load transaction data, please try again later",
  },
};
